export default __webpack_public_path__ + "static/media/learning-track.dbe793a7.svg";